import helper from 'store/helper';
import types from './types';

// Filters
const updateFilters = (items) =>
  helper.createAction(types.UPDATE_FILTERS, { items });

// Display items
const createDisplayItems = (items, mode) =>
  helper.createAction(types.CREATE_DISPLAY_ITEMS, { items, mode });
const createDisplayItemsSucceeded = (items, mode) =>
  helper.createAction(types.CREATE_DISPLAY_ITEMS_SUCCEEDED, { items, mode });
const setStatusDisplayItems = (status) =>
  helper.createAction(types.SET_STATUS_DISPLAY_ITEMS, { status });
const requestFailed = () => helper.createAction(types.REQUEST_FAILED);

const fetchDisplayItems = (mode) =>
  helper.createAction(types.FETCH_DISPLAY_ITEMS, { mode });
const fetchDisplayItemsSucceeded = (items, mode) =>
  helper.createAction(types.FETCH_DISPLAY_ITEMS_SUCCEEDED, { items, mode });

const adManagementSettingsActions = {
  updateFilters,
  createDisplayItems,
  setStatusDisplayItems,
  fetchDisplayItems,
  createDisplayItemsSucceeded,
  requestFailed,
  fetchDisplayItemsSucceeded,
};

export default adManagementSettingsActions;
